<template>
  <!-- 服务商 -->
  <div class="detail-wrap">
    <el-form ref="editForm" :model="formData">
      <div class="d-header clearfix">
        <div class="fl">
          <i class="el-icon-info"/>
          <!-- {{ dataId ? '查看' : '新增' }}服务商信息变更 -->
          变更单号：<span v-if="formData.changeNo" style="font-weight: 600;color: #2196f3;margin-right: 5px;">{{
            formData.changeNo
          }}</span>
          <span v-else class="information"> 待生成</span>
          <!-- 变更状态 -->
          <span v-if="!dataId" class="information"> 制单</span>
          <span v-else-if="formData.changeStat == 1" class="information">制单</span>
          <span v-else-if="formData.changeStat == 2" class="information">审核中</span>
          <span v-else-if="formData.changeStat == 5" class="information">已审核</span>
          <span v-else-if="formData.changeStat == 6" class="information">驳回</span>
          <span v-else-if="formData.changeStat == 99" class="information">取消</span>
          <span v-else class="information"></span>

        </div>
        <div class="fr">
          <el-button type="primary" plain class="button-sty" @click="submitChange" icon="el-icon-coffee-cup"
                     style="margin-right: 10px;" v-if="changeStat===1&&dataId&&!formData.processId&&snUserChangeCheck">
            提交审核
          </el-button>
          <el-button type="primary" plain class="button-sty" @click="auditChange" icon="el-icon-coffee-cup"
                     style="margin-right: 10px;"
                     v-if="(changeStat===2)&&dataId&&!formData.processId&&snUserChangeCheckPass">审核通过
          </el-button>
          <el-button type="primary" plain class="button-sty" @click="rejectChange" icon="el-icon-coffee-cup"
                     style="margin-right: 10px;" v-if="changeStat===2&&dataId&&!formData.processId&&snUserChangeReject">
            驳回
          </el-button>
          <el-button type="primary" plain class="button-sty" @click="cancelChange" icon="el-icon-coffee-cup"
                     style="margin-right: 10px;"
                     v-if="(changeStat===1||changeStat===6)&&dataId&&!formData.processId&&snUserChangeCancel">取消
          </el-button>
          <!--          <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-refresh-right">重置-->
          <!--          </el-button>-->
          <el-button type="primary" class="button-sty" icon="el-icon-check"
                     v-if="(snUserChangeSave||mySnUserChangeSave)&&(formData.changeStat !== 99&&formData.changeStat !== 2&&formData.changeStat !== 5)"
                     @click="saveData">保存
          </el-button>
        </div>
      </div>
      <div>
        <el-tabs v-model="activeName">
          <el-tab-pane label="用户信息" name="first">
            <!-- 基本信息 -->
            <div class="d-cont edit-mce-box">
              <div class="d-item">
                <div class="title first"><b>单据信息</b></div>
                <table class="table-detail">
                  <tbody>
                  <!-- 基础信息 -->

                  <tr>
                    <!-- <th>
                      <em class="f-red">*</em>
                      变更单号
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.changeNo" clearable :disabled="true" />
                    </td> -->
                    <th>
                      <em class="f-red">*</em>
                      变更类型
                    </th>
                    <td>
                      <el-form-item prop="languageId" :rules="[{ required: true, trigger: 'blur' }]">
                        <el-select v-model="changeType" style="width: 165px;"
                                   v-bind:disabled="this.dataId !== null && this.dataId !== ''">
                          <!--                        <el-option label="新增" :value="1" v-if="this.dataId === null || this.dataId === ''" />-->
                          <el-option label="新增" :value="1"/>
                          <el-option label="资料变更" :value="2"/>
                          <el-option label="暂挂" :value="3"/>
                          <el-option label="撤点" :value="4"/>
                          <el-option label="黑名单" :value="5"/>
                        </el-select>
                      </el-form-item>
                    </td>


                    <th>
                      <em class="f-red">*</em>
                      变更状态
                    </th>
                    <td>
                      <el-form-item prop="languageId" :rules="[{ required: true, trigger: 'blur' }]">
                        <el-select v-model="changeStat" style="width: 165px;" :disabled="true">
                          <el-option label="制单" :value="1"/>
                          <el-option label="审核中" :value="2"/>
                          <el-option label="已审核" :value="5"/>
                          <el-option label="驳回" :value="6"/>
                          <el-option label="取消" :value="99"/>
                        </el-select>
                      </el-form-item>
                    </td>
                  </tr>

                  </tbody>
                </table>
              </div>
              <div class="d-item">
                <div class="title first"><b>基础信息</b></div>
                <table class="table-detail">
                  <tbody>
                  <!-- 基础信息 -->
                  <tr>
                    <th>
                      <em class="f-red">*</em>
                      登录账号
                    </th>
                    <td>
                      <!--                        <el-input :disabled="dataId" type="text" @blur="inspection" autocomplete="off"
                                                v-model="formData.userAccount" clearable />-->
                      <el-input type="text" autocomplete="off" v-model="formData.userAccount" readonly
                                v-bind:disabled="changeType===1">
                        <i slot="suffix" class="el-input__icon el-icon-search"
                           @click="() => { if (changeType!==1) { showChangeSiteDialog = true } }"></i>
                      </el-input>
                    </td>
                    <th>
                      <em class="f-red">*</em>
                      用户名称
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.userName" clearable/>
                    </td>
                    <th>用户简称</th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.userShortName" clearable/>
                    </td>
                    <th>
                      <em class="f-red">*</em>
                      联系方式
                    </th>
                    <td>
                      <!-- <el-input type="text" autocomplete="off" v-model="formData.userMobile" clearable /> -->
                      <!--有bug，变更类型选资料变更无回显-->
                      <el-input type="text" autocomplete="off" v-model="callMobile1" clearable/>

                    </td>

                  </tr>
                  <tr>
                    <th>
                      <em class="f-red">*</em>
                      用户地址
                    </th>
                    <td>
                      <el-form-item>
                        <template>
                          <el-cascader :props="areaProps" v-model="areaValues" :clearable="true" @change="handleChange"
                                       ref="cascader" :options="areaOption">
                          </el-cascader>
                        </template>

                      </el-form-item>
                    </td>
                    <th>
                      <em class="f-red">*</em>
                      详细地址
                    </th>
                    <td>
                      <el-input type="text" :maxlength="10" autocomplete="off" v-model="formData.userAddress"
                                clearable/>
                    </td>

                    <th>

                      经度/纬度
                    </th>
                    <td>
                      <div>
                        <el-input type="text" autocomplete="off" v-model="formData.longitude" :disabled="true" clearable
                                  style="width: 49%!important;"/>
                        <el-input type="text" autocomplete="off" v-model="formData.latitude" :disabled="true" clearable
                                  style="width: 49%!important;margin-left:2%"/>
                      </div>
                    </td>

                    <th>
                      <em class="f-red">*</em>
                      网点状态
                    </th>
                    <td>
                      <el-form-item prop="languageId" :rules="[{ required: true, trigger: 'blur' }]">
                        <el-select v-model="formData.stat">
                          <el-option label="待审核" :value="1"/>
                          <el-option label="审核中" :value="2"/>
                          <el-option label="审核驳回" :value="3"/>
                          <el-option label="已审核" :value="5"/>
                          <!-- <el-option label="暂停" :value="91"/>
                        <el-option label="暂挂" :value="92"/>
                        <el-option label="撤消" :value="98"/>
                        <el-option label="黑名单" :value="99"/> -->
                        </el-select>
                      </el-form-item>
                    </td>
                  </tr>
                  <!-- <tr>
                  <th>用户照片</th>
                  <td colspan="7">
                    <div class="form_picture">
                      <div>
                        <el-upload style="display:flex"
                                   :action="api.uploadFileUrl"
                                   :on-remove="handleRemove1"
                                   list-type="picture-card"
                                   :file-list="picList1"
                                   :on-success="(res,file, fileList) => {handleSuccess1(res,file, fileList)}"
                                   :on-change="(files, fileList) => {handleImageChange(fileList)}"
                                   :auto-upload="true"
                                   :on-preview="handlePictureCardPreview"
                                   :headers="headers">
                          <i slot="default" class="el-icon-plus"></i>
                        </el-upload>
                      </div>
                    </div>
                  </td>
                </tr> -->
                  <tr>

                    <th>
                      业态标识
                    </th>
                    <td>
                      <el-form-item>
                        <el-select v-model="formData.snSiteInfoChangeDTO.businessFlag">
                          <el-option :value="0" label="无"/>
                          <el-option :value="1" label="新引入"/>
                          <el-option :value="2" label="更名"/>
                          <el-option :value="3" label="转型"/>
                        </el-select>
                      </el-form-item>
                    </td>

                    <th>
                      <!--                      <em class="f-red">*</em>-->
                      创建人
                    </th>
                    <td>{{ formData.createBy }}</td>
                    <th>
                      <!--                      <em class="f-red">*</em>-->
                      创建时间
                    </th>
                    <td>{{ formData.createTime }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div class="d-item">
                <div class="title first"><b>关键信息</b></div>
                <table class="table-detail">
                  <tbody>

                  <tr>
                    <th>
                      <em class="f-red">*</em>
                      服务商性质
                    </th>
                    <td>
                      <el-select v-model="formData.snSiteInfoChangeDTO.siteTypeName" @change="selectSiteType"
                                 style="width: 165px;">
                        <el-option v-for="item in siteTypeOption" :key="item.id" :label="item.label"
                                   :value="{value:item.id,label:item.label}"/>
                      </el-select>
                    </td>
                    <th>
                      <em class="f-red">*</em>
                      运营状态
                    </th>
                    <td>
                      <el-select v-model="formData.snSiteInfoChangeDTO.businessStat" placeholder=" 运营状态">
                        <el-option label="提报" :value="1"/>
                        <el-option label="备用" :value="2"/>
                        <el-option label="正常" :value="3"/>
                        <el-option label="清账" :value="4"/>
                        <el-option label="终止" :value="5"/>
                        <el-option label="黑名单" :value="9"/>

                      </el-select>
                      <!--                      <el-input type="text" autocomplete="off" v-model="formData.snSiteInfoChangeDTO.siteLevelName" clearable/>-->
                    </td>
                    <th>
                      <em class="f-red">*</em>
                      层级
                    </th>
                    <td v-if="this.currentSiteData !== null">
                      <el-select v-model="formData.snSiteInfoChangeDTO.siteFloorLevel" :disabled="true">
                        <el-option label="二级网点" :value="2"/>
                      </el-select>
                    </td>
                    <td v-else>
                      <el-select v-model="formData.snSiteInfoChangeDTO.siteFloorLevel" @change="() => {
                          this.formData.snSiteInfoChangeDTO.parentSiteName = null
                          this.formData.snSiteInfoChangeDTO.parentSiteId = null
                        }">
                        <el-option label="一级网点" :value="1"/>
                        <el-option label="二级网点" :value="2"/>
                      </el-select>
                    </td>

                    <th>
                      <em class="f-red">*</em>
                      所属机构名称
                    </th>
                    <td v-if="this.currentSiteData !== null">
                      <el-cascader v-model="orgValue"
                                   :options="orgOptions"
                                   @change="orgHandleChange"
                                   :props="{label:'name', value: 'id', checkStrictly: true, expandTrigger: 'hover'}"
                                   :disabled="true"></el-cascader>
                    </td>
                    <td v-else>
                      <el-cascader v-model="orgValue"
                                   :options="orgOptions"
                                   :props="{label:'name', value: 'id', checkStrictly: true, expandTrigger: 'hover'}"
                                   @change="orgHandleChange"></el-cascader>
                    </td>

                  </tr>
                  <tr>
                    <th>
                      编码
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.snSiteInfoChangeDTO.siteCode"
                                clearable/>
                    </td>
                    <th>
                      网点等级
                    </th>
                    <td>
                      <el-select v-model="formData.snSiteInfoChangeDTO.siteLevelId" placeholder="网点等级"
                                 @change="levelChange">
                        <el-option v-for="item in siteLevelOption" :key="item.value" :label="item.label"
                                   :value="item.value"/>
                      </el-select>
                      <!--                      <el-input type="text" autocomplete="off" v-model="formData.snSiteInfoChangeDTO.siteLevelName" clearable/>-->
                    </td>

                    <th>
                      上级网点
                    </th>
                    <td v-if="this.currentSiteData !== null">
                      <el-input type="text" autocomplete="off" v-model="formData.snSiteInfoChangeDTO.parentSiteName"
                                :disabled="true" clearable>
                        <i slot="suffix" class="el-input__icon el-icon-search"></i>
                      </el-input>
                    </td>
                    <td v-else>
                      <el-input type="text" autocomplete="off" v-model="formData.snSiteInfoChangeDTO.parentSiteName"
                                :disabled="formData.snSiteInfoChangeDTO.siteFloorLevel !== 2" clearable
                                :readonly="true">
                        <i slot="suffix" class="el-input__icon el-icon-search"
                           @click="() => { if (formData.snSiteInfoChangeDTO.siteFloorLevel == 2) { showSiteDialog = true } }"></i>
                      </el-input>
                    </td>
                    <th>
                      代理结算网点
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.snSiteInfoChangeDTO.settleSiteName"
                                clearable>
                        <i slot="suffix" class="el-input__icon el-icon-search" @click="showProxySiteDialog = true"></i>
                      </el-input>
                      <!--                      <el-input type="text" autocomplete="off"  clearable/>-->
                    </td>
                  </tr>
                  <tr>
                    <th>
                      开启派工到人
                    </th>
                    <td>
                      <el-form-item>
                        <el-select v-model="formData.snSiteInfoChangeDTO.kaiqiPaigongDaoren">
                          <el-option :value="0" :label="$t('common.No')" />
                          <el-option :value="1" :label="$t('common.yes')" />
                        </el-select>
                      </el-form-item>
                    </td>
                  </tr>
                  <!-- <tr>
                    <th>
                      星级
                    </th>
                    <td>
                      <el-select v-model="formData.snSiteInfoChangeDTO.starLevel" placeholder=" 星级">
                        <el-option label="一级" :value="1" />
                        <el-option label="二级" :value="2" />
                        <el-option label="三级" :value="3" />
                        <el-option label="四级" :value="4" />
                        <el-option label="五级" :value="5" />
                      </el-select>
                    </td>
                  </tr> -->
                  </tbody>
                </table>
              </div>
              <div class="d-item" style="margin-bottom: 50px;">
                <div class="title first">
                  <b>星级评价</b>
                  <el-button type="primary" class="button-sty btn_zdy"
                             @click="showStarLevelDialog2 = true; starLevelObj = null">
                    <i class="el-icon-plus"></i>
                    新增
                  </el-button>
                </div>
                <vxe-table :stripe="true"
                           :header-cell-style="{ background: '#F6FAFF', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080' }"
                           :header-row-style="{ height: '36px' }" :row-style="{ fontSize: '12px', background: '#fff' }"
                           show-overflow keep-source :row-config="{ height: 36 }" ref="xTable" height="150"
                           :column-config="{ resizable: true }"
                           :edit-config="{ trigger: 'click', mode: 'cell', showStatus: true }"
                           :data="formData.snSiteStarLevelChangeDTOS">
                  <vxe-column field="startLevelName" title="星级" width="110"/>
                  <vxe-column field="beginDate" title="开始时间" width="110"/>
                  <vxe-column field="endDate" title="结束时间" width="110"/>

                  <vxe-column title="操作" width="50">
                    <template #default="{ row }">
                      <a href="javascript:void(0);" class="a-link" @click="editStarLevel(row)">
                        <el-tooltip effect="dark" content="编辑" placement="top" popper-class="tooltip-skin">
                          <i class="el-icon-edit"/>
                        </el-tooltip>
                      </a>
                    </template>
                  </vxe-column>
                </vxe-table>


              </div>
              <!-- 财务信息 -->
              <div class="d-item">
                <div class="title first"><b>财务信息</b></div>
                <table class="table-detail">
                  <tbody>
                  <tr>
                    <!-- <th>
                    网点公司名称
                  </th>
                  <td>
                    <el-input type="text" autocomplete="off" v-model="formData.snSiteInfoChangeDTO.siteCompanyName"
                              clearable/>
                  </td> -->
                    <th>
                      税号
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.snSiteInfoChangeDTO.siteTaxNo"
                                clearable/>
                    </td>
                    <th>税率</th>
                    <td>
                      <vxe-input v-model="formData.snSiteInfoChangeDTO.siteInvoiceRate" autocomplete="off" clearable
                                 style="width: 165px"
                                 type="number" min="0" max="1" step="0.1"/>
                    </td>

                    <th>
                      发票类型
                    </th>
                    <td>
                      <el-form-item prop="languageId" :rules="[{ required: true, trigger: 'blur' }]">
                        <el-select v-model="formData.snSiteInfoChangeDTO.siteInvoiceType">
                          <el-option label="无发票" :value="0"/>
                          <el-option label="增值税普通发票" :value="1"/>
                          <el-option label="增值税专用发票" :value="2"/>
                        </el-select>
                      </el-form-item>
                    </td>
                  </tr>
                  <tr>
                    <th>
                      银行名称
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.snSiteInfoChangeDTO.bankName"
                                clearable/>
                    </td>
                    <th>
                      银行帐号
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.snSiteInfoChangeDTO.bankAccount"
                                clearable/>
                    </td>

                    <th>
                      银行帐户
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.snSiteInfoChangeDTO.bankAccountName"
                                clearable/>
                    </td>

                  </tr>
                  <tr>
                    <th>
                      法人单位
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.snSiteInfoChangeDTO.legalPersonCompany"
                                clearable/>
                    </td>
                    <th>
                      法人代表
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.snSiteInfoChangeDTO.legalPerson"
                                clearable/>
                    </td>

                    <th>
                      法人联系方式
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.snSiteInfoChangeDTO.legalPersonMobile"
                                clearable/>
                    </td>

                  </tr>
                  </tbody>
                </table>

              </div>
              <!-- 人员信息 -->
              <div class="d-item">
                <div class="title first"><b>人员信息</b></div>
                <table class="table-detail">
                  <tbody>
                  <tr>
                    <th>
                      联系人
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.snSiteInfoChangeDTO.siteMan"
                                clearable/>
                    </td>
                    <th>
                      联系人电话
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.snSiteInfoChangeDTO.siteManMobile"
                                clearable/>
                    </td>
                    <th>信息员或联系方式</th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.snSiteInfoChangeDTO.siteOrderMan"
                                clearable/>
                    </td>
                    <th>
                      财务员或联系方式
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.snSiteInfoChangeDTO.siteFinMan"
                                clearable/>
                    </td>
                  </tr>
                  <tr>
                    <th>
                      配件员或联系方式
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.snSiteInfoChangeDTO.sitePartsMan"
                                clearable/>
                    </td>
                    <th>
                      工程师负责人或联系方式
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.snSiteInfoChangeDTO.siteEngineerMan"
                                clearable/>
                    </td>
                    <th>
                      技术负责人或联系方式
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.snSiteInfoChangeDTO.siteTechMan"
                                clearable/>
                    </td>
                    <tr>
                      <th>网点介绍</th>
                      <td colspan="5">
                        <el-input class="annotate" type="textarea" :rows="1" placeholder="请输入内容" size="small"
                                  v-model="formData.snSiteInfoChangeDTO.siteDescription" clearable></el-input>
                      </td>
                    </tr>
                  </tr>

                  </tbody>

                </table>
                <!-- 人员信息 -->


                <vxe-table :stripe="true" style="margin-top: 10px;"
                           :header-cell-style="{ background: '#F6FAFF', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080' }"
                           :header-row-style="{ height: '36px' }" :row-style="{ fontSize: '12px', background: '#fff' }"
                           show-overflow keep-source :row-config="{ height: 36 }" ref="xTable" height="150"
                           :column-config="{ resizable: true }"
                           :edit-config="{ trigger: 'click', mode: 'cell', showStatus: true }"
                           :data="formData.basSiteManList">
                  <vxe-column field="custMobile" title="人员账号" width="150"/>
                  <vxe-column field="custPhone1" title="人员名称" width="110"/>
                  <vxe-column field="custPhone2" title="岗位" width="110"/>
                </vxe-table>
              </div>
              <!-- 地址信息 -->
              <div class="d-item" style="margin-bottom: 50px;">
                <div class="title first">
                  <b>地址信息</b>
                  <el-button type="primary" class="button-sty btn_zdy" @click="showAreaDialog = true; areaObj = null">
                    <i class="el-icon-plus"></i>
                    新增地址
                  </el-button>
                </div>
                <vxe-table :stripe="true"
                           :header-cell-style="{ background: '#F6FAFF', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080' }"
                           :header-row-style="{ height: '36px' }" :row-style="{ fontSize: '12px', background: '#fff' }"
                           show-overflow keep-source :row-config="{ height: 36 }" ref="xTable" height="150"
                           :column-config="{ resizable: true }"
                           :edit-config="{ trigger: 'click', mode: 'cell', showStatus: true }"
                           :data="formData.basCustAddressList">
                  <vxe-column field="addressTypeName" title="地址类型" width="110"/>
                  <vxe-column field="addressMan" title="联系人姓名" width="110"/>
                  <vxe-column field="addressMobile" title="联系人电话" width="110"/>
                  <vxe-column title="地址" width="180">
                    <template #default="{ row }">
                      <span>{{ row.province }}{{ row.city }}{{ row.county }}{{ row.town }}</span>
                    </template>
                  </vxe-column>
                  <vxe-column field="address" title="详细地址" width="180"/>
                  <!-- <vxe-column field="isDefault" title="是否默认地址" width="100">
                  <template #default="{ row }">
                    <span v-if="row.isDefault==1">是</span>
                    <span v-if="row.isDefault==0">否</span>
                  </template>
                </vxe-column> -->
                  <vxe-column title="操作" width="50">
                    <template #default="{ row }">
                      <a href="javascript:void(0);" class="a-link" @click="editArea(row)">
                        <el-tooltip effect="dark" content="编辑" placement="top" popper-class="tooltip-skin">
                          <i class="el-icon-edit"/>
                        </el-tooltip>
                      </a>
                    </template>
                  </vxe-column>
                </vxe-table>


              </div>
              <!-- 流程 -->
              <wfView visible-key="showEdit" :wfData="wfData" :parent-target="_self"
                      @reload="$reloadHandle"></wfView>
            </div>
          </el-tab-pane>
          <el-tab-pane label="信息认证" name="second">
            <div class="d-cont edit-mce-box">
              <div class="d-item">
                <div class="title first"><b>业务设置</b></div>
                <table class="table-detail">
                  <tbody>
                  <tr>
                    <th>
                      接收短信手机1
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.snSiteInfoChangeDTO.siteMessagePhone1"
                                clearable/>
                    </td>
                    <th>
                      接收短信手机2
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.snSiteInfoChangeDTO.siteMessagePhone2"
                                clearable/>
                    </td>
                    <th>
                      第三方接口appid
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.snSiteInfoChangeDTO.thirdRequestAppid"
                                clearable/>
                    </td>
                    <th>
                      第三方接口appsecret
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off"
                                v-model="formData.snSiteInfoChangeDTO.thirdRequestAppsecret"
                                clearable/>
                    </td>

                  </tr>
                  <tr>
                    <th>远程费计算起点</th>
                    <td>
                      <el-input type="text" autocomplete="off"
                                v-model="formData.snSiteInfoChangeDTO.siteDistanceBasAddress"
                                clearable/>
                    </td>
                    <th>
                      远程费基数
                    </th>
                    <td>
                      <vxe-input type="number" style="width: 165px" autocomplete="off"
                                 v-model="formData.snSiteInfoChangeDTO.siteDisBas" clearable/>
                    </td>
                    <th>
                      远程费费率
                    </th>
                    <td>
                      <vxe-input type="number" style="width: 165px" autocomplete="off"
                                 v-model="formData.snSiteInfoChangeDTO.siteDisRate" clearable/>
                    </td>

                    <th>
                      封顶远程费
                    </th>
                    <td>
                      <vxe-input type="number" style="width: 165px" autocomplete="off"
                                 v-model="formData.snSiteInfoChangeDTO.siteTopDis" clearable/>
                    </td>


                  </tr>
                  <tr>
                    <th>
                      是否全国性网点
                    </th>
                    <td>
                      <el-form-item prop="languageId" :rules="[{ required: true, trigger: 'blur' }]">
                        <el-select v-model="formData.snSiteInfoChangeDTO.siteOverAllArea">
                          <el-option label="否" :value="0"/>
                          <el-option label="是" :value="1"/>
                        </el-select>
                      </el-form-item>
                    </td>
                    <th>
                      是否自动派单
                    </th>
                    <td>
                      <el-form-item prop="languageId" :rules="[{ required: true, trigger: 'blur' }]">
                        <el-select v-model="formData.snSiteInfoChangeDTO.isAutoIssue">
                          <el-option label="否" :value="0"/>
                          <el-option label="是" :value="1"/>
                        </el-select>
                      </el-form-item>
                    </td>
                    <th>
                      是否自动接单
                    </th>
                    <td>
                      <el-form-item prop="languageId" :rules="[{ required: true, trigger: 'blur' }]">
                        <el-select v-model="formData.snSiteInfoChangeDTO.siteAutoAccept">
                          <el-option label="否" :value="0"/>
                          <el-option label="是" :value="1"/>
                        </el-select>
                      </el-form-item>
                    </td>
                    <th>
                      是否预约超时考核
                    </th>
                    <td>
                      <el-form-item prop="languageId" :rules="[{ required: true, trigger: 'blur' }]">
                        <el-select v-model="formData.snSiteInfoChangeDTO.checkBeyondBookdate">
                          <el-option label="否" :value="0"/>
                          <el-option label="是" :value="1"/>
                        </el-select>
                      </el-form-item>
                    </td>

                  </tr>

                  <tr>
                    <th>
                      是否自动确认完工
                    </th>
                    <td>
                      <el-form-item prop="languageId" :rules="[{ required: true, trigger: 'blur' }]">
                        <el-select v-model="formData.snSiteInfoChangeDTO.autoComfirmOrder">
                          <el-option label="否" :value="0"/>
                          <el-option label="是" :value="1"/>
                        </el-select>
                      </el-form-item>
                    </td>
                    <th>
                      配件起订金额
                    </th>
                    <td>
                      <el-input v-model="formData.snSiteInfoChangeDTO.minPartsApplyAmount" autocomplete="off" clearable
                                type="number" :min="0" :max="9999"/>
                    </td>

                    <th>
                      限冲帐金额
                    </th>
                    <td>
                      <el-input v-model="formData.snSiteInfoChangeDTO.limitPartsBalance" autocomplete="off" clearable
                                type="number" :min="0" :max="9999"/>
                    </td>
                  </tr>

                  </tbody>
                </table>
              </div>
              <div class="d-item">
                <div class="title first">
                  <!-- <b>// 考核科目</b> -->
                  <!-- <el-button type="primary" class="button-sty btn_zdy" @click="showDialog = true; areaObj = null">
                    <i class="el-icon-plus"></i>
                    新增
                  </el-button> -->
                  <el-button type="primary" class="button-sty btn_zdy" @click="showPartsPpo = true;">
                    <i class="el-icon-plus"></i>
                    新增
                  </el-button>
                  <el-button type="primary" class="button-sty btn_zdy" @click="deleteData" style="margin-left: 10px;">
                    <i class="el-icon-delete"></i>
                    删除
                  </el-button>
                </div>
                <vxe-table v-if="isRouterAlive" :stripe="true"
                           :header-cell-style="{ background: '#F6FAFF', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080' }"
                           :header-row-style="{ height: '36px' }"
                           :row-style="{height: '30px', fontSize: '12px', background: '#fff' }" show-overflow
                           keep-source
                           ref="xTable" height="150" :row-config="{ height: 36 }" :column-config="{ resizable: true }"
                           :edit-config="{ trigger: 'click', mode: 'cell', showStatus: true }"
                           :data="formData.snSiteNocheckChangeList"
                           @checkbox-change="selectChangeEvent2"
                           @checkbox-all="selectChangeEvent2"
                >
                  <vxe-colgroup title="网点免考核科目">
                    <vxe-column type="checkbox" width="35"/>
                    <vxe-column field="name" title="考核科目" width="150"/>
                    <vxe-column title="开始时间~结束时间" width="500">
                      <template #default="{ row }">
                        <el-date-picker
                          v-model="row.timeSlot"
                          type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期">
                        </el-date-picker>
                      </template>
                    </vxe-column>
                    <!--                    <vxe-column title="操作" width="50">
                                          <template #default="{ row }">
                                            <a href="javascript:void(0);" class="a-link" @click="editArea(row)">
                                              <el-tooltip effect="dark" content="编辑" placement="top" popper-class="tooltip-skin">
                                                <i class="el-icon-edit" />
                                              </el-tooltip>
                                            </a>
                                          </template>
                                        </vxe-column>-->
                  </vxe-colgroup>

                </vxe-table>
              </div>
              <div class="d-item">
                <div class="title first"><b>认证信息</b></div>
                <table class="table-detail">
                  <tbody>

                  <tr>
                    <th>网点照片</th>
                    <td colspan="">
                      <div class="form_picture">
                        <div>
                          <!-- <el-upload :action="api.uploadFileUrl" :auto-upload="true" :file-list="picList1"
                            :headers="headers" :on-change="(files, fileList) => { handleImageChange(fileList) }"
                            :on-preview="handlePictureCardPreview" :on-remove="handleRemove1"
                            :on-success="(res, file, fileList) => { handleSuccess1(res, file, fileList) }"
                            list-type="picture-card" style="display:flex">
                            <i slot="default" class="el-icon-plus"></i>
                          </el-upload> -->
                          <photoUpload :photo-url.sync="formData.userPhoto"/>

                        </div>
                      </div>
                      <!-- <baseUpload accept="image/png, image/jpeg" multi="true" :showSortInput="true"></baseUpload> -->
                    </td>
                    <th>资质照片</th>
                    <td>
                      <div>

                        <photoUpload :photo-url.sync="formData.snSiteInfoChangeDTO.abilityPhoto"/>
                      </div>
                    </td>

                    <th>门头照片</th>
                    <td>
                      <div>
                        <photoUpload :photo-url.sync="formData.snSiteInfoChangeDTO.shopPhoto"/>

                      </div>
                    </td>


                  </tr>
                  <tr>
                    <th>营业执照正本</th>
                    <td>
                      <div>
                        <photoUpload :photo-url.sync="formData.snSiteInfoChangeDTO.businessPhoto"/>

                      </div>
                    </td>
                    <th>营业执照副本</th>
                    <td>
                      <div>
                        <photoUpload :photo-url.sync="formData.snSiteInfoChangeDTO.businessPhoto2"/>

                      </div>
                    </td>
                    <th>法人身份证正面</th>
                    <td>
                      <div>
                        <photoUpload :photo-url.sync="formData.snSiteInfoChangeDTO.legalPersonPhoto"/>

                      </div>
                    </td>
                    <th>法人身份证反面</th>
                    <td>
                      <div>
                        <photoUpload :photo-url.sync="formData.snSiteInfoChangeDTO.legalPersonPhoto2"/>

                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>

              </div>

            </div>
          </el-tab-pane>
          <el-tab-pane label="合同信息" name="second2">
            <div class="d-cont edit-mce-box">
              <div class="d-item" style="position: relative;">
                <div class="title first" style="width:30%"><b>合同信息</b></div>
                <div style="margin: -30px 0px 0px 51vw;;">
                  <el-button @click="addItem" type="primary" class="button-sty btn_zdy" style="margin-right: 5px;">
                    增加
                  </el-button>
                  <el-button @click="deleteItem(item, index)" type="danger" class="button-sty btn_zdy">删除
                  </el-button>
                </div>
                <!--                    <el-form ref="form" :rules="formRules" :inline="true" :model="form" label-width="8vw">-->
                <el-form ref="form" :inline="true" :model="form" label-width="8vw">
                  <contract-item v-for="(item, index) in form.dynamicItem" :key="index" :item.sync="item" :siteId="formData.siteId"/>
                </el-form>

              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="服务品类" name="third">
            <!-- 服务品类 -->
            <div class="d-cont edit-mce-box">

              <div class="d-item" style="height: calc(calc(100vh + -180px ));">
                <vxe-table :stripe="true" height="100%"
                           :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '50%' }"
                           :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                           style="width:50%;" show-overflow row-id="id" :data="formData.itemCategoryList"
                           :tree-config="{ transform: true }"
                           :checkbox-config="{ labelField: 'name', checkRowKeys: formData.selectedItemCategoryIdList }"
                           @checkbox-change="itemCategorySelectChangeEvent"
                           @checkbox-all="itemCategorySelectChangeEvent" v-if="itemCategoryShow">
                  <vxe-column type="checkbox" width="80" tree-node></vxe-column>
                  <vxe-column field="categoryName" title="服务类型"></vxe-column>
                </vxe-table>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="服务区域" name="fourth">
            <!-- 服务区域 -->
            <div class="d-cont edit-mce-box">
              <div class="d-item">
                <el-form-item>
                  <template>
                    <el-input style="width: 15vw;margin-right: 5px;" @focus="showItemPop = true"
                              placeholder="请选择"></el-input>
                    <!-- <el-cascader :props="areaProps1" :clearable="true" @change="handleChange1" ref="cascaderAddr">
                    </el-cascader>
                    <el-button type="primary" class="button-sty btn_zdy" @click="addAreaData">
                      <i class="el-icon-plus"></i>
                      添加服务区域
                    </el-button> -->
                    <el-button style="margin: 5px 0;" type="primary" class="button-sty btn_zdy"
                               @click="handleDeleteList">
                      <i class="el-icon-delete"></i>
                      批量删除
                    </el-button>
                  </template>
                </el-form-item>

                <div class="d-item" style="height: calc(calc(100vh + -215px ));">

                  <vxe-table ref="filterTable" height="100%" class="table_item pic_item"
                             :column-config="{ resizable: true }"
                             style="width: 56%;" :stripe="true"
                             :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                             :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                             show-overflow
                             :data="formData.snSiteAreaList" @checkbox-all="areaSelectAll"
                             @checkbox-change="areaSelect">
                    <vxe-column type="checkbox" width="55">
                    </vxe-column>

                    <vxe-column field="areaNamePath" title="省市区地址" width="`100%-115`">
                    </vxe-column>

                    <vxe-column title="操作" width="60">
                      <template #default="{ row }">
                        <div @click="handleDelete(row.id)">
                          <el-tooltip :enterable="false" effect="dark" content="删除" placement="top"
                                      popper-class="tooltip-skin">
                            <i class="el-icon-delete" style="font-size: 18px; color: #00c4b3"></i>
                          </el-tooltip>
                        </div>
                      </template>
                    </vxe-column>
                  </vxe-table>
                </div>
                <!--                <el-button type="primary" class="button-sty btn_zdy" @click="showAreaDialog=true">-->
                <!--                  <i class="el-icon-plus"></i>-->
                <!--                  新增-->
                <!--                </el-button>-->
                <!--                <el-table ref="filterTable" border height="350" :data="table_area" class="table_item pic_item"-->
                <!--                          style="width: 95%;"-->
                <!--                          :header-cell-style="{ background: '#F6FAFF',padding: '0',borderTop: '1px solid #eaeaea',fontSize:'12px',color:'#808080'}"-->
                <!--                          :header-row-style="{height:'36px'}"-->
                <!--                          :row-style="{height:'30px',fontSize:'12px', background: '#fff'}">-->
                <!--                  <vxe-column type="selection" width="55">-->
                <!--                  </vxe-column>-->
                <!--                  <vxe-column prop="areaLevel" label="地区" width="600"/>-->

                <!--                  <vxe-column label="操作">-->
                <!--                    <template slot-scope="scope">-->
                <!--                      <div @click="handleDelete2(scope.$index)">-->
                <!--                        <el-tooltip :enterable="false" effect="dark" content="删除" placement="top"-->
                <!--                                    popper-class="tooltip-skin">-->
                <!--                          <i class="el-icon-delete" style="font-size: 18px; color: #00c4b3"></i>-->
                <!--                        </el-tooltip>-->
                <!--                      </div>-->
                <!--                    </template>-->
                <!--                  </vxe-column>-->
                <!--                </el-table>-->
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="服务类型" name="five">
            <!-- 服务类型 -->
            <div class="d-cont edit-mce-box">
              <div class="d-item" style="height: calc(calc(100vh + -180px ));">
                <vxe-table :stripe="true" height="100%"
                           :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '50%' }"
                           :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                           style="width:50%;" show-overflow resizable row-id="id" :data="formData.serviceTypeList"
                           :tree-config="{ transform: true }"
                           :checkbox-config="{ labelField: 'name', checkRowKeys: formData.selectedServiceTypeIdList }"
                           @checkbox-change="serviceTypeSelectChangeEvent" @checkbox-all="serviceTypeSelectChangeEvent"
                           v-if="serviceTypeShow">
                  <vxe-column type="checkbox" width="80" tree-node></vxe-column>
                  <vxe-column field="serviceTypeName" title="服务类型"></vxe-column>
                </vxe-table>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="服务渠道" name="six">
            <!-- 服务区域 -->
            <div class="d-cont edit-mce-box">
              <div class="d-item">
                <div style="height: calc(calc(100vh + -180px ));">
                  <vxe-table :stripe="true" height="100%"
                             :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                             :row-config="{ height: 30, isHover: true, padding: 0, }"
                             :row-style="{ fontSize: '12px', }" style="width:50%;"
                             :checkbox-config="{ labelField: 'name', checkRowKeys: formData.selectedBuyChannelIdList }"
                             @checkbox-change="buyChannelChangeEvent"
                             @checkbox-all="buyChannelChangeEvent" show-overflow resizable
                             :column-config="{ resizable: true }"
                             :data="formData.buyChannelList"
                             :tree-config="{transform: true}"
                             row-id="id" v-if="buyChannelShow"
                  >

                    <vxe-column type="checkbox" width="40"/>
                    <vxe-column field="buyChannelName" title="购买渠道"></vxe-column>
                  </vxe-table>
                </div>
              </div>
            </div>
          </el-tab-pane>

          <el-tab-pane  :label="'继承网点'" name="inherit">
            <!-- 继承服务商 -->
            <div class="d-cont edit-mce-box">
              <div class="d-item">
                <el-form-item>
                  <template>
                    <el-button class="button-sty btn_zdy" type="primary" @click="showInheritPpo = true;">
                      <i class="el-icon-plus"></i>
                      新增
                    </el-button>
                    <el-button class="button-sty btn_zdy" style="margin-left: 10px;" type="primary" @click="deleteInheritData">
                      <i class="el-icon-delete"></i>
                      删除
                    </el-button>
                  </template>
                </el-form-item>

                <div class="d-item" style="height: calc(calc(100vh + -215px ));">

                  <vxe-table v-if="isRouterAlive" ref="inheritTable" height="100%" :column-config="{ resizable: true }"
                             :data="formData.snSiteInheritChangeDTOS"
                             :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '200%' }"
                             :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                             :stripe="true" class="table_item pic_item"  show-overflow style="width: 56%;"
                             @checkbox-all="inheritSelectAll" @checkbox-change="inheritSelectAll">
                    <vxe-column type="checkbox" width="55">
                    </vxe-column>

                    <vxe-column field="inheritSiteAccount"  :title="'继承服务商登陆帐号'" width="150">
                    </vxe-column>
                    <vxe-column field="inheritSiteName"  :title="'继承服务商用户名称'" width="250">
                    </vxe-column>

                  </vxe-table>
                </div>
              </div>
            </div>
          </el-tab-pane>

        </el-tabs>
      </div>

    </el-form>

    <el-image-viewer v-if="dialogVisible" :on-close="closeImgViewer" :url-list="dialogImageUrlList"/>
    <!--    <el-dialog :visible.sync="dialogVisible">-->
    <!--      <img width="100%" :src="dialogImageUrl" alt="">-->
    <!--    </el-dialog>-->

    <site-dialog v-if="showSiteDialog" @commit="commitSelectedRow" :visiable.sync="showSiteDialog" multi="true"
                 :excludeId="dataId" :orgId="this.formData.snSiteInfoChangeDTO.orgId" :siteFloorLevel="1"/>
    <site-dialog v-if="showProxySiteDialog" @commit="commitSelectedRow1" :visiable.sync="showProxySiteDialog"
                 multi="true"
                 :excludeId="dataId" :orgId="this.formData.snSiteInfoChangeDTO.orgId"/>
    <site-dialog v-if="showChangeSiteDialog" @commit="commitSelectedRow2" :visiable.sync="showChangeSiteDialog"
                 multi="true"
                 :excludeId="dataId"/>
    <preconditionDialog2 v-if="showPreconditionDialog" @confirm="commitSelectedRow"
                         :visiable.sync="showPreconditionDialog" :symptomId="symptomId" multi="true"/>
    <areaDialog v-if="showAreaDialog" @commitData="commitAreaData" :areaObj="areaObj" :visiable.sync="showAreaDialog"
                multi="true"/>
    <!-- 星级 -->
    <starLevel v-if="showStarLevelDialog2" @commitData="commitStarLevelData" :visiable.sync="showStarLevelDialog2"
               :starLevelObj="starLevelObj"
               multi="true"/>
    <!-- /考核科目 -->
    <!--    <checkSubjectDialog v-if="showDialog" :param="param" :visiable.sync="showDialog" @commitSelect="commitSelect"/>-->
    <examine
      v-if="showPartsPpo"
      @confirm="confirm"
      :visiable.sync="showPartsPpo"
      :replacePartsObj="getReplacePartsObj"
      multi="true"
    />
    <!-- 地区选择 -->
    <addressDialog :visiable.sync="showItemPop" v-if="showItemPop" @addressList="addressList"/>

    <!-- 继承服务商 -->
    <siteInheritDialog v-if="showInheritPpo" :visiable.sync="showInheritPpo" multi="true"
                       @commit="confirmInherit" />

    <!--    &lt;!&ndash; 合同上传 &ndash;&gt;-->
    <!--    <text2Dialog v-if="showVideo" @commitVideo="commitVideo" :visiable.sync="showVideo" multi="true"/>-->
    <!--    &lt;!&ndash; 合同PDF &ndash;&gt;-->
    <!--    &lt;!&ndash; <htDialog  v-if="htDialog" :visiable.sync="htDialog" ></htDialog> &ndash;&gt;-->

  </div>
</template>

<script>
import Tinymce from '@/components/Tinymce';
import request from "@/router/axios";
import preconditionDialog from './dialog';
import areaDialog from './areadialog.vue';
import store from "@/store";
import examine from '@/views/dialogCommon/examineDialog.vue'

import api from "@/api/projectApi";
import {echoFileFormat, uploadFileFormat} from "@/util/uploadFormat";
import {dictType, loadDictData} from "@/config/dictType";
import siteDialog from "@/views/dialogCommon/radioSiteDialog.vue"
import preconditionDialog2 from '@/views/dialogCommon/partsInvDialog.vue';
import {mapGetters} from "vuex";
import {editPageMixins, siteMixins} from "@/mixins/tabChang";
// 星级
import starLevel from '@/views/service/wangdian/facilitator/starLevel.vue';
// 考核科目
import checkSubjectDialog from "@/views/dialogCommon/duoCheckSubjectDialog.vue";
// 流程
import wfView from "@/views/dialogCommon/wfMsgDialog.vue";
// 图片
import photoUpload from "@/components/formItem/photoUpload.vue"
// 文件上传
import textUpload from "@/components/formItem/textUpload1.vue"
import {fetchTree} from "@/api/admin/dept";
// 地区选择
import addressDialog from '@/views/dialogCommon/addressDialog.vue';
// 合同上传
import text2Dialog from '@/views/dialogCommon/text2Dialog.vue'
// 电子合同
import htDialog from './htdialog.vue';
import ContractItem from "@/views/dialogCommon/contractItem.vue";
import siteInheritDialog from "@/views/dialogCommon/radioSiteDialog.vue";


export default {
  mixins: [siteMixins, editPageMixins],
  inject: ['reload'],
  name: 'edit',
  props: {
    _dataId: [String, Number],
    processId: [String, Number],
    showSave: [Boolean]
  },
  components: {
    siteInheritDialog,
    ContractItem,
    htDialog,
    text2Dialog,
    addressDialog,
    textUpload,
    photoUpload,
    examine,
    wfView,
    starLevel,
    Tinymce,
    areaDialog,
    preconditionDialog,
    preconditionDialog2,
    checkSubjectDialog,
    siteDialog,
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer')
  },
  data() {
    return {
      htDialog: false,
      showVideo: false,

      showItemPop: false,
      showInheritPpo:false,
      addressUrl: '/basic/basArea/getListByIdList',
      // 号码验证
      callMobile1: '',
      isRouterAlive: true,
      selectedNocheckData: [],
      selectedInheritData: [],
      showPartsPpo: false,
      pickerOptions0: null,
      pickerOptions1: null,
      loading: false,
      // 流程
      processId: '',
      showEdit: false,


      queryParams: {
        deptName: null
      },

      wfData: {
        wfEntityId: ''
      },
      snUserChangeSave: false,
      mySnUserChangeSave: false,
      snUserChangeCheck: false,
      snUserChangeCheckPass: false,
      snUserChangeReject: false,
      snUserChangeCancel: false,
      snUserChangeReview: false,
      form: {
        dynamicItem: [
          {
            changeId: '',  // 变更单ID,关联sn_user_change.id;
            contractName: '', //合同名称
            contractNo: '', //合同号
            contractYear: '', //合同年月
            contractFile: '1', //合同文件
            contractBeginTime: '', //合同开始时间
            contractEndTime: '', //合同结束时间
            contractStat: '', //合同状态:0未生效;5已生效;9已过期
            contractSignTime: '', //合同签署时间
          }
        ]
      },

      changeType: 1, // 变更类型
      changeStat: 1, // 变更状态
      formData: {
        textUrl: [],//合同文件
        snSiteNocheckChangeList: [],
        snSiteNocheckChangeDTOS: [],
        snSiteInheritChangeDTOS:[],
        basCustAddressList: [],
        basSiteManList: [],
        snSiteStarLevelChangeDTOS: [], //星级
        id: '',
        createBy: '',
        createTime: '',
        changeNo: '', // 变更单号
        changeType: '', // 变更类型
        changeStat: 1, // 变更状态
        siteId: '', // 网点ID
        userType: 2,  // 用户类型:2网点
        userAccount: null,  // 登陆帐号,可重复
        userName: '',  // 用户名称
        userShortName: '',  // 用户简称
        userMobile: '',  // 联系方式,可重复
        userProvince: null,  // 省
        userCity: null,  // 市
        userCounty: null,  // 区
        userTown: null,  // 镇
        areaId: '',  // 地区ID,关联bas_area.id
        userAddress: '',  // 详细地址
        longitude: '',  // 地址经度
        latitude: '',  // 地址纬度
        userPhoto: '',  // 用户图片
        stat: 1,  // 状态:1待审核;2审核中;3审核驳回;5已审核;91暂停、92暂挂、98撤消、99黑名单;小于5的状态都可以登陆

        snSiteInfoChangeDTO: { //网点拓展表
          changeId: '',  // 变更单ID,关联sn_user_change.id;

          siteType: '',  // 性质：1个人服务商；2特约服务商;3经销商;4配件代理商
          siteTypeName: '', // 性质名称,冗余字段
          businessStat: '', // 运营状态:1提报、2备用、3正常、4清账、5终止、9黑名单
          starLevel: '', // 星级：1一级，2二级，3三级，4四级，5五级
          siteCode: '',  // 编码
          orgId: '',  // 所属中心，关联脚手架机构表sys_dept.dept_id
          orgName: '',  // 所属机构名称,冗余字段
          orgIdPath: '',  // 所属机构ID路径,冗余字段.重要
          siteLevelId: '',  // 等级ID，关联脚手架数据字典项目表sys_dict_item.id
          siteLevelName: '',  // 等级名称,冗余字段
          siteFloorLevel: 1,  // 层级:1、一级网点；2、二级网点；
          parentSiteId: '',  // 上级网点ID,关联sn_user.id;网点层级为2时必有值
          settleSiteId: '',  // 代理结算网点ID,关联sn_user.id

          siteTaxNo: '',  // 税号
          siteInvoiceType: 0,  // 网点：发票类型（0无发票；1、增值税普通发票；2、增值税专用发票）
          siteInvoiceRate: 0,  // 网点：税率
          bankName: '',  // 银行名称
          bankAccount: '',  // 银行帐号
          bankAccountName: '',  // 银行帐户
          legalPersonCompany: '', // 法人单位
          legalPerson: '', // 法人代表
          legalPersonMobile: '', // 法人联系方式

          isAutoIssue: 0,  // 是否自动派单：0否1是
          siteAutoAccept: 0,  // 是否自动接单：0否1是
          siteMessagePhone1: '',  // 网点：接收短信手机1
          siteMessagePhone2: '',  // 网点：接收短信手机2
          siteOverAllArea: 0,  // 是否全国性网点:0否1是
          siteDistanceBasAddress: '',  // 远程费计算起点
          siteDisBas: null,  // 远程费基数。千万不要默认为0，要为null
          siteDisRate: null,  // 远程费费率。千万不要默认为0，要为null
          siteTopDis: null,  // 封顶远程费。千万不要默认为0，要为null
          thirdRequestAppsecret: '',  // 第三方接口appsecret(随机生成，长度32位)
          checkBeyondBookdate: 0,  // 是否预约超时考核:0否1是
          autoComfirmOrder: 0,  // 是否自动确认完工：0否1是
          minPartsApplyAmount: 0,//配件起订金额
          limitPartsBalance: 0, // 限冲帐金额

          siteCompanyName: '',  // 网点公司名称
          abilityPhoto: '',  // 资质照片
          shopPhoto: '',  // 门头照片
          legalPersonPhoto: '', // 法人身份证正面
          legalPersonPhoto2: '', // 法人身份证反面
          businessPhoto: '',  // 营业执照正本照片
          businessPhoto2: '',  // 营业执照副本照片

          contractFile: '',  // 合同文件
          contractBeginTime: '',  // 合同开始时间
          contractEndTime: '',  // 合同结束时间

          siteMan: '',  // 联系人
          siteManMobile: '', //联系人电话
          siteManPid: '',  // 联系人身份证号
          siteOrderMan: '',  // 信息员或联系方式
          siteFinMan: '',  // 财务员或联系方式
          sitePartsMan: '',  // 配件员或联系方式
          siteEngineerMan: '',  // 工程师负责人或联系方式
          siteTechMan: '',  // 技术负责人或联系方式
          siteDescription: '',  // 网点介绍

          parentSiteName: '',  // 上级网点
          settleSiteName: '',  // 代理结算网点
          businessFlag: '',//业态标识
          kaiqiPaigongDaoren:0,//开启派工到人：0否；1是
        },
        SnSiteContractChangeDTO: { //合同表
          changeId: '',  // 变更单ID,关联sn_user_change.id;
          contractName: '', //合同名称
          contractNo: '', //合同号
          contractYear: '', //合同年月
          contractFile: '', //合同文件
          contractBeginTime: '', //合同开始时间
          contractEndTime: '', //合同结束时间
          contractStat: '', //合同状态:0未生效;5已生效;9已过期
          contractSignTime: '', //合同签署时间
        },
        snSiteContractChangeDTOS: [],//合同集合表
        snSiteAddressChangeDTOS: [], //地址信息表
        // snSiteCategoryList: [],
        // snSiteServiceTypeList: [],
        snSiteAreaList: [], // 服务区域

        serviceTypeList: [],
        selectedServiceTypeIdList: [], //服务类型
        itemCategoryList: [],
        selectedItemCategoryIdList: [], //网点服务品类
        buyChannelList: [],
        selectedBuyChannelIdList: [] //服务渠道
      },

      areaOption: [],
      areaValues: [],
      areaProps: {
        lazy: true,
        checkStrictly: true,
        lazyLoad: this.cascaderLazyLoad
      },
      // picList1: [],
      // picList2: [],
      // picList3: [],
      // picList4: [],
      // picList5: [],
      // picList6: [],
      // picList7: [],
      file: [],
      siteLevelOption: [],
      siteTypeOption: [], //网点性质下拉框
      showSiteDialog: false,
      showProxySiteDialog: false,
      showChangeSiteDialog: false,

      areaProps1: {
        lazy: true,
        emitPath: false,
        checkStrictly: true,
        lazyLoad: this.cascaderLazyLoad1
      },
      area: {
        temp: {},
        checkedArray: []
      },
      areaData: [],

      orgOptions: [],
      orgValue: '',


      showPreconditionDialog: false,
      areaObj: null,
      showAreaDialog: false,
      starLevelObj: null,
      showStarLevelDialog2: false,

      isIndeterminate: [true, false],
      isIndeterminate2: true,
      // 以上卡片数据
      //  第四个页面表---服务类型


      activeName: 'first',
      dialog: {
        one: false,
      },
      lan: 'zh_CN',
      isEdit: false,
      tabIndex: 'first',
      dataId: null,

      showProductCategoryDialog: false,
      languageDTOs: [],
      dialogImageUrl: '',
      dialogImageUrlList: [],
      dialogVisible: false,
      uploadDisabled: false,

      itemCategoryShow: true,
      serviceTypeShow: true,
      buyChannelShow: true

    };
  },
  computed: {
    getReplacePartsObj() {
      return {
        basPartsReplaceIdList: this.formData.basPartsReplaceIdList,
        dataId: this.formData.id
      }
    },
    ...mapGetters(["permissions"]),
    api() {
      return api
    },
    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId
      };
    }
  },
  watch: {
    // callMobile1: {
    //   handler(newVal, oldVal) {
    //     // console.log(newVal,"新值");
    //     this.formData.userMobile = newVal

    //     var numReg = /^[0-9]+$/
    //     var numRe = new RegExp(numReg)
    //     if (!numRe.test(this.formData.userMobile)) {
    //       this.$message.error("请输入正确的11位手机号码");
    //     } else if (this.formData.userMobile.length > 11) {
    //       this.$message.error("手机号码不能超过11位");
    //       this.formData.userMobile = this.formData.userMobile.slice(0, 11);
    //       this.callMobile1 = this.formData.userMobile
    //     }
    //   },
    //   deep: true, // 加这个属性，深度监听
    // },
    'formData.basCustAddressList': {
      handler(n) {
        console.log('sadf', n)
      }
    },
    file: {
      handler(newVal, oldVal) {
        this.formData.snSiteInfoChangeDTO.contractFile = uploadFileFormat(newVal)
      },
      deep: true, // 加这个属性，深度监听
    },
  },
  created() {
    this.snUserChangeSave = this.permissions['snUserChangeSave']
    this.mySnUserChangeSave = this.permissions['mySnUserChangeSave']
    this.snUserChangeCheck = this.permissions['snUserChangeCheck']
    this.snUserChangeCheckPass = this.permissions['snUserChangeCheckPass']
    this.snUserChangeReject = this.permissions['snUserChangeReject']
    this.snUserChangeCancel = this.permissions['snUserChangeCancel']
    this.snUserChangeReview = this.permissions['snUserChangeReview']
    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
    if (this.processId && !isNaN(this.processId)) this.wfData.wfEntityId = this.processId;

    // console.log(this.tenant,"tenant的值");
  },
  mounted() {
    this.loadDictData()
    this.loadOrgData()
    this.loadSiteTypeData()
    this.getData();
    // console.log(this.tenant, "tenant的值");
    console.log(this._dataId, "_dataId的值");
  },
  methods: {
    // // 文件下载
    // handleDownload(Vname, Vurl) {
    //   this.$mask.open()
    //
    //   console.log(Vname, Vurl, "视频下载");
    //   // let url=file.type
    //   let url = Vurl
    //   let name = Vname
    //
    //   const x = new XMLHttpRequest()
    //   x.open('GET', url, true)
    //   x.responseType = 'blob'
    //   x.onload = function () {
    //     const url = window.URL.createObjectURL(x.response)
    //     const a = document.createElement('a')
    //     a.href = url
    //     a.download = name
    //     a.click()
    //   }
    //   x.send()
    //   this.$mask.close()
    //
    //
    //   // window.open(url,'_blank');
    // },
    // 预览
    openVideo(value) {
      let host = window.location.hostname
      console.log(host, "域名111");

      let url = `https://` + host + value
      console.log(url, "url 名字");
      window.open("https://view.xdocin.com/view?src=" + encodeURIComponent(url));


      // window.open(this.formData.vedioUrl, '_blank')
    },
    // 文件上传文件
    commitVideo(data) {
      console.log('选中的多文件数据', data)
      let combinedArray = [...this.formData.textUrl, ...data];
      console.log(combinedArray);
      this.formData.textUrl = combinedArray
      console.log(this.formData.textUrl, "6369");
    },
    addressList(data) {
      console.log(data, "穿过i来");

      this.$http({
        url: this.addressUrl,
        method: 'post',
        data: {
          idList: data
        }
      }).then(res => {
        console.log(res, "选择的地区");
        let tempArray = this.formData.snSiteAreaList
        res.data.data.forEach(item => {
          tempArray.push({
            id: item.id,
            areaNamePath: item.areaNamePath
          })
        })
        this.formData.snSiteAreaList = this.uniqueArr(tempArray)
        // if(res!==''){
        //   this.areaData.push(res.data.data)
        // }

      })
    },

    selectChangeEvent2(data) {
      console.log('选中数据', data)
      this.selectedNocheckData = data.records
    },
    deleteData() {
      let temp = this.formData.snSiteNocheckChangeList
      if (!this.selectedNocheckData || this.selectedNocheckData.length === 0) {
        this.$message.error('请先选中要删除的数据')
        return
      }
      this.selectedNocheckData.forEach(item => {
        temp = temp.filter(item1 => item1.id != item.id)
      })
      console.log("this.formData.snSiteNocheckChangeList1", this.formData.snSiteNocheckChangeList)
      this.formData.snSiteNocheckChangeList = temp
      console.log("this.formData.snSiteNocheckChangeList2", this.formData.snSiteNocheckChangeList)
    },

    reload() {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },

    confirm(data) {
      console.log('选中', data)
      if (!this.formData.snSiteNocheckChangeList) {
        this.formData.snSiteNocheckChangeList = []
      }

      data.forEach(item => {
        let flag = false
        this.formData.snSiteNocheckChangeList.forEach(item1 => {
          console.log(" item1.id------", item1.id)
          flag = (item1.id == item.id) || flag
        })

        console.log(" flag-----", flag)
        if (!flag) {
          this.formData.snSiteNocheckChangeList.push({id: item.id, name: item.name})
        }
      })
      console.log(' this.formData.snSiteNocheckChangeList选中', this.formData.snSiteNocheckChangeList)
      this.reload()
      // console.log("回访数据", data)
      // let filter = this.formData.snSiteNocheckChangeList.filter(item => item.id !== data.id)
      // filter.push(data)
      // console.log(filter, "filter的值");
      // // this.formData.snSiteStarLevelDTOS = filter
      // filter.forEach(item => {
      //   this.formData.snSiteNocheckChangeList.push(item)
      // })
      // this.loadReplacementAccessories()
    },

    // 日期选择器设置，使开始时间小于结束时间，并且所选时间早于当前时间
    changeDate(contractBeginTime, contractEndTime) {
      console.log("contractBeginTime", new Date(contractBeginTime).getTime())
      console.log("contractEndTime", new Date(contractEndTime).getTime())
//因为date1和date2格式为 年-月-日， 所以这里先把date1和date2转换为时间戳再进行比较
      let date1 = new Date(contractBeginTime).getTime()
      let date2 = new Date(contractEndTime).getTime()
      this.pickerOptions0 = {
        disabledDate: (time) => {
          if (date2 != "") {
            return time.getTime() > date2;
          }/* else {
            return time.getTime() > Date.now();
          }*/
        }
      }
      this.pickerOptions1 = {
        disabledDate: (time) => {
          return time.getTime() < date1;
        }
      }
      console.log(" this.pickerOptions0", this.pickerOptions0)
      console.log(" this.pickerOptions1", this.pickerOptions1)
    },

    commitStarLevelData(data) {
      console.log("data", data)
      let filter = this.formData.snSiteStarLevelChangeDTOS.filter(item => item.starLevelId !== data.starLevelId)
      filter.push(data)
      this.formData.snSiteStarLevelChangeDTOS = filter
      console.log("this.formData.snSiteStarLevelChangeDTOS", this.formData.snSiteStarLevelChangeDTOS)
    },

    //获取网点性质名称
    selectSiteType(data) {
      this.formData.snSiteInfoChangeDTO.siteType = data.value;
      this.formData.snSiteInfoChangeDTO.siteTypeName = data.label;
    },

    submitChange() {//提交审核
      this.formData.changeStat = 2
      this.updateChangeStat(2)
    },

    auditChange() {//审核通过
      this.formData.changeStat = 5
      this.passTheAudit()
      /*this.updateChangeStat(5)*/
    },

    rejectChange() {//驳回
      this.formData.changeStat = 6
      this.updateChangeStat(6)
    },

    cancelChange() {//取消
      this.formData.changeStat = 99
      this.updateChangeStat(99)
    },
    updateChangeStat(changeStat) { //更新变更状态
      console.log("this.dataId", this.dataId)
      console.log("changeStat", changeStat)
      this.$http({
        url: api.snUserChange.updateChangeStatUrl,
        method: 'post',
        data: {
          changeId: this.dataId,
          changeStat: changeStat
        }
      }).then(res => {
        if (res.data.data) {
          this.$message({
            message: '操作成功',
            type: 'success'
          });
        }
        this.reload()
      })
    },
    passTheAudit() { // 审核通过
      this.$http({
        url: api.snUserChange.passTheAuditUrl,
        method: 'post',
        data: {
          id: this.dataId
        }
      }).then(res => {
        if (res.data.data) {
          this.$message({
            message: '操作成功',
            type: 'success'
          });
        }
        this.reload()
      })
    },

    editArea(row) {
      this.areaObj = row
      this.showAreaDialog = true
    },
    editStarLevel(row) {
      this.starLevelObj = row
      this.showStarLevelDialog2 = true
    },
    addItem() {
      this.form.dynamicItem.push({
        changeId: '',  // 变更单ID,关联sn_user_change.id;
        contractName: '', //合同名称
        contractNo: '', //合同号
        contractYear: '', //合同年月
        contractFile: '1', //合同文件
        contractBeginTime: '', //合同开始时间
        contractEndTime: '', //合同结束时间
        contractStat: '', //合同状态:0未生效;5已生效;9已过期
        contractSignTime: '', //合同签署时间
      });
    },
    sure(form) {
      console.log(this.form.dynamicItem.length, "length");
      this.$refs[form].validate(valid => {
        if (valid) {
          alert("submit!");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    deleteItem(item, index) {
      console.log(index);
      this.form.dynamicItem.splice(index, 1);
      console.log(this.form.dynamicItem, "删除");
    },
    commitAreaData(data) {
      console.log("保存地址", data)
      let filter = this.formData.basCustAddressList.filter(item => item.id != data.id)
      if (data.isDefault == 1) {
        filter.forEach(item => {
          item.isDefault = 0
        })
      }
      filter.push(data)

      this.formData.basCustAddressList = filter
      console.log("保存地址this.formData.basCustAddressList", this.formData.basCustAddressList)
    },
    commitData(data) {
      console.log(data, 'commitData')
      let temp = this.formData.basCustAsseList.filter(item => item.id != data.id)
      temp.push(data)
      this.formData.basCustAsseList = temp
      // if (isRefresh) {
      //   this.getTableData()
      // } else {
      //   if (this.formData.basCustAsseList.length !== 0) {
      //     this.formData.basCustAsseList = this.formData.basCustAsseList.filter(item => item.id !== data.id)
      //   }
      //   this.formData.basCustAsseList.push(data)
      // }
      // console.log(this.formData.basCustAsseList, '---------')
    },
    buyChannelChangeEvent({records}) {
      this.formData.selectedBuyChannelIdList = records.map(item => item.id)
      console.log('购买渠道选中', this.formData.selectedBuyChannelIdList)
    },
    closeImgViewer() {
      this.dialogVisible = false
    },

    inspection() {
      if (this.formData.userAccount) {
        this.$http({
          url: api.snUser.inspectionUrl,
          method: 'post',
          data: {
            value: this.formData.userAccount,
            id: this.formData.id,
          }
        }).then(res => {
          if (!res.data.data) {
            this.$message.warning("登录账号已存在，请重新输入")
            this.formData.userAccount = null
          }
        })
      }
    },

    // 服务品类复选框
    itemCategorySelectChangeEvent({records}) {
      // 拿到所有id
      let temp = records.map(item => item.id)

      // 获取有子类的父id
      let parentTemp = new Set()
      records.forEach(item => {
        if (item.parentId != 0) {
          parentTemp.add(item.parentId)
        }
      })

      // 去除有子类的父id
      let temp1 = []
      temp.forEach(item => {
        if (!parentTemp.has(item)) {
          temp1.push(item)
        }
      })
      this.formData.selectedItemCategoryIdList = temp1
      console.log('选中的服务类型id', temp1)
    },

    // 服务类型复选框
    serviceTypeSelectChangeEvent({records}) {
      // 拿到所有id
      let temp = records.map(item => item.id)

      // 获取有子类的父id
      let parentTemp = new Set()
      records.forEach(item => {
        if (item.parentId != 0) {
          parentTemp.add(item.parentId)
        }
      })

      // 去除有子类的父id
      let temp1 = []
      temp.forEach(item => {
        if (!parentTemp.has(item)) {
          temp1.push(item)
        }
      })
      this.formData.selectedServiceTypeIdList = temp1
      console.log('选中的服务类型id', temp1)
    },



    commitSelectedRow(data) {
      this.formData.snSiteInfoChangeDTO.parentSiteId = data.id
      this.formData.snSiteInfoChangeDTO.parentSiteName = data.name
      this.orgValue = data.orgId
      this.formData.snSiteInfoChangeDTO.orgId = data.orgId
      this.formData.snSiteInfoChangeDTO.orgName = data.orgName
      this.formData.snSiteInfoChangeDTO.orgIdPath = data.orgIdPath
    },
    commitSelectedRow1(data) {
      this.formData.snSiteInfoChangeDTO.settleSiteId = data.id
      this.formData.snSiteInfoChangeDTO.settleSiteName = data.name
      this.orgValue = data.orgId
      this.formData.snSiteInfoChangeDTO.orgId = data.orgId
      this.formData.snSiteInfoChangeDTO.orgName = data.orgName
      this.formData.snSiteInfoChangeDTO.orgIdPath = data.orgIdPath
    },
    commitSelectedRow2(data) {
      console.log('获取网点id', data.id)
      this.$http({
        url: api.snUser.getDataUrl,
        method: 'post',
        data: {id: data.id}
      }).then(res => {
        console.log('获取网点详情', res.data.data)
        this.formData = res.data.data
        this.callMobile1 = this.formData.userMobile

        this.formData.snSiteNocheckChangeList = []
        this.formData.snSiteInheritChangeDTOS = []
        this.formData.snSiteInfoChangeDTO = res.data.data.snSiteInfoDTO
        this.orgValue = this.formData.snSiteInfoChangeDTO.orgId
        this.formData.selectedItemCategoryIdList = res.data.data.selectedItemCategoryIdList
        this.formData.areaId = res.data.data.areaId
        this.form.dynamicItem = res.data.data.snSiteContractDTOS
        this.formData.basCustAddressList = res.data.data.snSiteAddressDTOS
        this.formData.snSiteStarLevelChangeDTOS = res.data.data.snSiteStarLevelDTOS
        this.formData.siteId = res.data.data.id;
        this.formData.snSiteNocheckChangeList = res.data.data.snSiteNocheckDTOS;
        this.formData.snSiteInheritChangeDTOS = res.data.data.snSiteInheritDTOList
        // this.picList1 = echoFileFormat(this.formData.userPhoto)
        // this.picList2 = echoFileFormat(this.formData.snSiteInfoChangeDTO.abilityPhoto)
        // this.picList3 = echoFileFormat(this.formData.snSiteInfoChangeDTO.shopPhoto)
        // this.picList4 = echoFileFormat(this.formData.snSiteInfoChangeDTO.businessPhoto)
        // this.picList5 = echoFileFormat(this.formData.snSiteInfoChangeDTO.businessPhoto2)
        // this.picList6 = echoFileFormat(this.formData.snSiteInfoChangeDTO.legalPersonPhoto)
        // this.picList7 = echoFileFormat(this.formData.snSiteInfoChangeDTO.legalPersonPhoto2)

        this.formData.snSiteContractChangeDTOS = [];
        this.form.dynamicItem.forEach(item => {
          // var files = "";
          // item.contractFile.forEach(item1 =>{
          //   files += item1.url + ","
          // })
          // if(files != null && files != ""){
          //   files = files.slice(0,files.length-1);
          // }
          this.formData.snSiteContractChangeDTOS.push(item)
          // this.formData.snSiteContractChangeDTOS.push({
          //   contractName: item.contractName,
          //   contractBeginTime: item.contractBeginTime, contractEndTime: item.contractEndTime,
          //   contractFile: item.contractFile, contractNo: item.contractNo, contractSignTime: item.contractSignTime,
          //   contractStat: item.contractStat, contractYear: item.contractYear
          // })
        })

        this.file = echoFileFormat(this.formData.snSiteInfoChangeDTO.contractFile)
        this.echoAddress()
        this.formData.id = '';
        this.itemCategoryShow = false
        this.serviceTypeShow = false
        this.buyChannelShow = false
        setTimeout(() => {
          this.itemCategoryShow = true
          this.serviceTypeShow = true
          this.buyChannelShow = true
        }, 2)

      })
    },

    // 网点等级改变
    levelChange() {
      if (this.formData.snSiteInfoChangeDTO.siteLevelId !== '') {
        this.siteLevelOption.forEach(item => {
          if (item.id === this.formData.snSiteInfoChangeDTO.siteLevelId) {
            this.formData.snSiteInfoChangeDTO.siteLevelName = item.label
          }
        })
      }
    },

    // 加载机构数据
    loadOrgData() {
      fetchTree(this.queryParams).then(res => {
        console.log(res.data.data)
        this.orgOptions = res.data.data
        // res.data.data.forEach(item => {
        //   let temp = {
        //     value: item.id,
        //     label: item.name,
        //   }
        //   if (item.hasChild) {
        //     temp.children = []
        //     item.child.forEach(item1 => {
        //       temp.children.push({
        //         value: item1.deptId,
        //         label: item1.name
        //       })
        //     })
        //   }
        //
        //   this.orgOptions.push(temp)
        // })
        // console.log("this.orgOptions",this.orgOptions)
      })
    },

    orgHandleChange(data) {
      if (data.length !== 0) {
        this.$http({
          url: '/admin/dept/' + data[data.length - 1],
          method: 'get'
        }).then(res => {
          console.log('选中机构', res.data.data)
          this.formData.snSiteInfoChangeDTO.orgId = res.data.data.deptId
          this.formData.snSiteInfoChangeDTO.orgName = res.data.data.name
          this.formData.snSiteInfoChangeDTO.orgIdPath = res.data.data.orgIdPath
          this.formData.snSiteInfoChangeDTO.parentSiteId = ''
          this.formData.snSiteInfoChangeDTO.parentSiteName = ''
          this.formData.snSiteInfoChangeDTO.settleSiteId = ''
          this.formData.snSiteInfoChangeDTO.settleSiteName = ''
        })

      }
    },


    // 添加地区列表
    addAreaData() {
      if (this.area.temp.level < 3) {
        this.$message.warning('请至少选择到市级地址')
      } else {
        if (this.area.temp.level === 3 || this.area.temp.level === 4) {
          this.$http({
            url: api.basArea.getAreaPathDataUrl,
            method: 'post',
            data: {
              parentId: this.area.temp.id
            }
          }).then(res => {
            let tempArray = this.formData.snSiteAreaList
            if (tempArray == null) {
              tempArray = []
            }
            res.data.data.forEach(item => {
              tempArray.push({
                id: item.id,
                areaNamePath: item.areaNamePath
              })
            })
            this.formData.snSiteAreaList = this.uniqueArr(tempArray)
          })
        } else if (this.area.temp.level === 5) {
          this.$http({
            url: api.basArea.getAreaPathDataUrl,
            method: 'post',
            data: {
              areaId: this.area.temp.id,
            }
          }).then(res => {
            let tempArray = this.formData.snSiteAreaList
            res.data.data.forEach(item => {
              tempArray.push({
                id: item.id,
                areaNamePath: item.areaNamePath
              })
            })
            this.formData.snSiteAreaList = this.uniqueArr(tempArray)
          })
        }
      }
    },

    // 去重
    uniqueArr(arr) {
      let result = [];
      arr.forEach((item) => {
        if (!result.some(m => m.id === item.id)) {
          result.push(item);
        }
      });
      return result;
    },

    // 单个地区删除
    handleDelete(id) {
      console.log(id)
      this.$baseConfirm('您确定要删除吗？').then(() => {
        this.formData.snSiteAreaList = this.formData.snSiteAreaList.filter(item => item.id !== id)
      })
    },

    // 批量删除地区
    handleDeleteList() {
      console.log(this.area.checkedArray)
      if (this.area.checkedArray === undefined || this.area.checkedArray.length === 0) {
        this.$message.warning('请先勾选地址')
      } else {
        this.$baseConfirm('您确定要删除吗？').then(() => {
          this.area.checkedArray.forEach(item => {
            this.formData.snSiteAreaList = this.formData.snSiteAreaList.filter(item1 => item1.id !== item.id)
          })
          this.area.checkedArray = []
        })
      }
    },

    // 单个地址选中
    areaSelect(data) {
      console.log(data, '选中')
      if (this.area.checkedArray === undefined) {
        this.area.checkedArray = []
      }
      if (data.checked) {
        this.area.checkedArray.push(data.row)
      } else {
        this.area.checkedArray = this.area.checkedArray.filter(item => item.id !== data.row.id)
      }
      console.log('askdfksd', this.area.checkedArray)
    },

    // 地址全选
    areaSelectAll(selection) {
      console.log(selection)
      this.area.checkedArray = []
      let records = selection.records
      records.forEach(item => {
        this.area.checkedArray.push(item)
      })
      console.log(this.area.checkedArray.length)
    },

    // 地址三级联动
    handleChange1() {
      const areaNode = this.$refs["cascaderAddr"].getCheckedNodes();
      this.area.temp = {
        id: areaNode[0].value,
        level: areaNode[0].level
      }
      const panelRefs = this.$refs.cascaderAddr.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.activePath.forEach(item => {
          if (item.children.length === 0) {
            panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
          }
        })
      }
    },

    cascaderLazyLoad1(node, resolve) {
      if (!node) {
        return false
      }
      request({
        url: api.basArea.getList,
        method: 'post',
        data: {
          parentId: node.value
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        const childrens = response.data.data || {};

        const nodes = childrens.map(item => ({
          value: item.id,
          label: item.areaName,
          leaf: Number(item.hasChild) > 0
        }))
        // 通过调用resolve将子节点数据返回，通知组件数据加载完成
        resolve(nodes);
      })
    },


    // 加载数据字典中网点等级
    loadDictData() {
      loadDictData(dictType.branchLevel).then(res => {
        this.siteLevelOption = []
        res.data.data.forEach(item => {
          this.siteLevelOption.push({
            label: item.label,
            value: item.id
          })
        })
      })
    },

    // 加载数据字典中网点性质
    loadSiteTypeData() {
      loadDictData(dictType.siteQuality).then(res => {
        this.siteTypeOption = []
        res.data.data.forEach(item => {
          this.siteTypeOption.push({
            label: item.label,
            id: item.id
          })
        })
      })
    },

    handleChange() {
      const areaNode = this.$refs["cascader"].getCheckedNodes();
      console.log('handleNode', areaNode)
      if (areaNode != null && areaNode[0] != null && areaNode[0].value != null) {
        if (areaNode[0].level == 1) {
          this.formData.country = areaNode[0].label;
          this.formData.userProvince = null;
          this.formData.userCity = null;
          this.formData.userCounty = null;
          this.formData.userTown = null;
        } else if (areaNode[0].level == 2) {
          this.formData.userProvince = areaNode[0].label;
          this.formData.userCity = null;
          this.formData.userCounty = null;
          this.formData.userTown = null;
        } else if (areaNode[0].level == 3) {
          this.formData.userCity = areaNode[0].label;
          this.formData.userCounty = null;
          this.formData.userTown = null;
        } else if (areaNode[0].level == 4) {
          this.formData.userCounty = areaNode[0].label;
          this.formData.userTown = null;
        } else if (areaNode[0].level == 5) {
          this.formData.userTown = areaNode[0].label;
        }
        this.formData.areaId = areaNode[0].value
      } else {
        this.formData.areaId = null;
        this.formData.country = null;
        this.formData.userProvince = null;
        this.formData.userCity = null;
        this.formData.userCounty = null;
        this.formData.userTown = null;
      }

      const panelRefs = this.$refs.cascader.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
      }

    },

    cascaderLazyLoad(node, resolve) {
      if (!node) {
        return false
      }
      this.$http({
        url: api.basArea.getList,
        method: 'post',
        data: {
          parentId: node.value
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        if (node.root) {
          const childrens = response.data.data || {};
          const childNodes = childrens.map(item => ({
            value: item.id,
            label: item.areaName,
            leaf: Number(item.hasChild) !== 0
          }))
          console.log('childNodes', childNodes)
          // 通过调用resolve将子节点数据返回，通知组件数据加载完成
          resolve(childNodes);
        } else {
          const childrens = response.data.data || {};
          let childNodes = []
          let temp = ''
          console.log(node.children, 'child')
          if (node.children.length !== 0) {
            temp = node.children
            childrens.forEach(item => {
              let flag = false
              temp.forEach(item1 => {
                if (item1.value == item.id) {
                  flag = true  // 当前节点已存在此数据，不追加
                }
              })
              if (!flag) {
                childNodes.push({
                  value: item.id,
                  label: item.areaName,
                  leaf: Number(item.hasChild) !== 0
                })
              }
            })
            resolve(childNodes);
          } else {
            childrens.forEach(item => {
              childNodes.push({
                value: item.id,
                label: item.areaName,
                leaf: Number(item.hasChild) !== 0
              })
            })
            resolve(childNodes);
          }
        }
      })
    },
    // 地址数据回显
    echoAddress() {
      if (this.formData.areaId !== null && this.formData.areaId !== '') {
        // this.cascaderShow = false
        this.$http({
          url: api.basArea.echoAddressUrl,
          method: 'post',
          data: {id: this.formData.areaId}
        }).then(res => {
          this.areaOption = res.data.data.options
          this.areaValues = res.data.data.values
          this.area = res.data.data.names
        })
      }
    },


    saveData() {
      let rules = {
        siteMessagePhone1: [{prop: '接收短信手机1', required: false, type: 'phone'}],
        siteMessagePhone2: [{prop: '接收短信手机2', required: false, type: 'phone'}],
        // siteManMobile: [{prop: '联系人电话', required: false, type: 'phone'}],
      }
      this.$validate(this.formData.snSiteInfoChangeDTO, rules).then(() => {

        console.log("this.formData.snSiteNocheckList--->", this.formData.snSiteNocheckChangeList);
        if (this.formData.snSiteNocheckChangeList != null && this.formData.snSiteNocheckChangeList.length > 0) {
          this.formData.snSiteNocheckChangeList.forEach(item => {
            if (item.timeSlot === undefined || item.timeSlot === null) {
              this.$message.warning('免考核科目请选择有效时间范围')
            }
          })
          this.formData.snSiteNocheckChangeDTOS = this.formData.snSiteNocheckChangeList.map(item => ({
            checkSubjectId: item.id,
            name: item.name,
            beginDate: item.timeSlot[0],
            endDate: item.timeSlot[1]
          }));
        }


        this.formData.snSiteContractChangeDTOS = []
        this.form.dynamicItem.forEach(item => {
          this.formData.snSiteContractChangeDTOS.push(item)
          // this.formData.snSiteContractChangeDTOS.push({
          //   contractName: item.contractName,
          //   contractBeginTime: item.contractBeginTime, contractEndTime: item.contractEndTime,
          //   // contractFile: item.contractFile,
          //   contractNo: item.contractNo, contractSignTime: item.contractSignTime,
          //   contractStat: item.contractStat, contractYear: item.contractYear,
          //   fileDTOList: item.fileDTOList,
          // })
        })



        // this.formData.snSiteContractChangeDTOS = this.form.dynamicItem;
        this.formData.snSiteAddressChangeDTOS = this.formData.basCustAddressList;
        this.formData.changeType = this.changeType;
        this.formData.changeStat = this.changeStat;
        console.log('保存数据', this.formData)
        let formData = this.formData;
        if (!formData.userProvince) {
          this.$message.warning('请选择地址')
          return
        }
        if (formData.selectedItemCategoryIdList.length === 0) {
          this.$message.warning('请选择服务品类')
          return
        }
        if (formData.snSiteAreaList.length === 0) {
          this.$message.warning('请选择服务区域')
          return
        }
        if (formData.selectedServiceTypeIdList.length === 0) {
          this.$message.warning('请选择服务类型')
          return
        }
        if (formData.selectedBuyChannelIdList.length === 0) {
          this.$message.warning('请选择服务渠道')
          return
        }
        // if (this.callMobile1.length!=11) {
        //     this.$message.error("请输入正确的联系方式");
        //     return
        //   }
        this.$baseConfirm('您确定要保存吗？').then(() => {
          if (this.changeStat === 6) { //驳回状态重新保存的时候把状态改为制单
            this.formData.changeStat = 1;
            this.changeStat = 1;
          }
          this.$mask.open()
          this.formData.userMobile = this.callMobile1

          this.$http({
            url: this.isEdit ? api.snUserChange.updateDataUrl : api.snUserChange.addDataUrl,
            method: 'post',
            data: this.formData
          }).then(() => {
            this.$message.success("保存成功！")
            this.reload()
            this.$emit('goBackIndex')
            this.$mask.close()

          }).catch(e => {
            console.error(e)
            this.$message.error("保存失败！")
            this.$mask.close()

          })
        })

      })
    },


    handleCheckAllChange($event, val) {
      let temp = []
      if ($event) {  // 全选
        val.childList.forEach(item => {
          temp.push(item.id)
        })
      }
      val.checked = temp
      val.isIndeterminate = false
    },
    handleCheckedCitiesChange($event, val) {
      val.isIndeterminate = val.checked.length > 0 && val.childList.length > val.checked.length
      if (val.checked.length === val.childList.length) {
        val.checkAll = true
      } else {
        val.checkAll = false
      }
    },


    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        /*this.changeType = 2;*/
        this.$http({
          url: api.snUserChange.getDataUrl,
          method: 'post',
          data: {
            id: this.dataId
          },
          isLoading: true,
          modalStrictly: true,
        }).then(res => {
          // console.log(res.data.data)
          console.log("this.formData前", this.formData)
          this.formData = res.data.data
          this.callMobile1 = this.formData.userMobile

          this.changeType = this.formData.changeType
          this.changeStat = this.formData.changeStat
          this.orgValue = this.formData.snSiteInfoChangeDTO.orgId
          console.log("this.formData后", this.formData)
          this.formData.basCustAddressList = this.formData.snSiteAddressChangeDTOS;
          this.form.dynamicItem = this.formData.snSiteContractChangeDTOS;
          // this.form.dynamicItem.forEach(item =>{
          //   let arr2=[]
          //   arr2.push(
          //     {
          //       url:item.contractFile,
          //       name:item.contractName
          //     }
          //   )
          //   item.contractFile = arr2
          // })
          if (this.formData.snSiteNocheckChangeDTOS.length > 0) {
            this.formData.snSiteNocheckChangeList = this.formData.snSiteNocheckChangeDTOS.map(item => ({
              id: item.checkSubjectId,
              name: item.name,
              timeSlot: [item.beginDate, item.endDate]
            }));
          }
          // this.picList1 = echoFileFormat(this.formData.userPhoto)
          // this.picList2 = echoFileFormat(this.formData.snSiteInfoChangeDTO.abilityPhoto)
          // this.picList3 = echoFileFormat(this.formData.snSiteInfoChangeDTO.shopPhoto)
          // this.picList4 = echoFileFormat(this.formData.snSiteInfoChangeDTO.businessPhoto)
          // this.picList5 = echoFileFormat(this.formData.snSiteInfoChangeDTO.businessPhoto2)
          // this.picList6 = echoFileFormat(this.formData.snSiteInfoChangeDTO.legalPersonPhoto)
          // this.picList7 = echoFileFormat(this.formData.snSiteInfoChangeDTO.legalPersonPhoto2)
          this.file = echoFileFormat(this.formData.snSiteInfoChangeDTO.contractFile)
          this.echoAddress()
        })
      } else {
        this.$http({
          url: api.snUserChange.initDataUrl,
          method: 'post',
          data: {}
        }).then(res => {
          console.log(res.data.data, 'init')
          let data = res.data.data;
          this.formData.serviceTypeList = data.serviceTypeList
          this.formData.itemCategoryList = data.itemCategoryList
          this.formData.buyChannelList = data.buyChannelList
          // this.formData.snSiteCategoryList = data.snSiteCategoryList
        })
      }
      if (this.currentSiteData !== null) { //网点端
        console.log('网点数据', this.currentSiteData)
        this.formData.snSiteAreaList = this.currentSiteData.snSiteAreaList
        console.log('asdfkdsa', this.formData.snSiteAreaList)
        this.formData.snSiteInfoChangeDTO.siteFloorLevel = 2
        this.formData.snSiteInfoChangeDTO.parentSiteName = this.currentSiteData.userName
        this.formData.snSiteInfoChangeDTO.parentSiteId = this.currentSiteData.id
        this.orgValue = this.currentSiteData.snSiteInfoDTO.orgId
        this.formData.snSiteInfoChangeDTO.orgId = this.currentSiteData.snSiteInfoDTO.orgId
        this.formData.snSiteInfoChangeDTO.orgName = this.currentSiteData.snSiteInfoDTO.orgName
        this.formData.snSiteInfoChangeDTO.orgIdPath = this.currentSiteData.snSiteInfoDTO.orgIdPath
      }
    },

    handleImageChange(fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },
    handleRemove1() {
      this.picList1 = []
    },
    handleSuccess1(res, file, fileList) {
      console.log(res.data.url, "url")
      this.picList1 = echoFileFormat(res.data.url)
    },
    handleRemove2() {
      this.picList2 = []
    },
    handleSuccess2(res, file, fileList) {
      console.log(res.data.url, "url")
      this.picList2 = echoFileFormat(res.data.url)
    },
    handleRemove3() {
      this.picList3 = []
    },
    handleSuccess3(res, file, fileList) {
      console.log(res.data.url, "url")
      this.picList3 = echoFileFormat(res.data.url)
    },
    handleRemove4() {
      this.picList4 = []
    },
    handleSuccess4(res, file, fileList) {
      console.log(res.data.url, "url")
      this.picList4 = echoFileFormat(res.data.url)
    },

    handleRemove5() {
      this.picList5 = []
    },
    handleSuccess5(res, file, fileList) {
      console.log(res.data.url, "url")
      this.picList5 = echoFileFormat(res.data.url)
    },

    handleRemove6() {
      this.picList6 = []
    },
    handleSuccess6(res, file, fileList) {
      console.log(res.data.url, "url")
      this.picList6 = echoFileFormat(res.data.url)
    },

    handleRemove7() {
      this.picList7 = []
    },
    handleSuccess7(res, file, fileList) {
      console.log(res.data.url, "url")
      this.picList7 = echoFileFormat(res.data.url)
    },

    pdfHandleRemove() {
      this.file = []
    },
    pdfHandleSuccess(res, file, fileList) {
      console.log(res.data.url, "url")
      this.file = echoFileFormat(res.data.url)
    },
    inheritSelectAll(data) {
      console.log('选中数据', data)
      this.selectedInheritData = data.records
    },
    deleteInheritData() {
      let temp = this.formData.snSiteInheritChangeDTOS
      if (!this.selectedInheritData || this.selectedInheritData.length === 0) {
        this.$message.error('请先选中要删除的数据')
        return
      }
      this.selectedInheritData.forEach(item => {
        temp = temp.filter(item1 => item1.id != item.id)
      })
      console.log("this.formData.snSiteInheritChangeDTOS", this.formData.snSiteInheritChangeDTOS)
      this.formData.snSiteInheritChangeDTOS = temp
      console.log("this.formData.snSiteInheritChangeDTOS", this.formData.snSiteInheritChangeDTOS)
      this.$refs['inheritTable'].removeCheckboxRow();
    },
    confirmInherit(data) {
      console.log('选中', data)
      if (!this.formData.snSiteInheritChangeDTOS) {
        this.formData.snSiteInheritChangeDTOS = []
      }

      //data.forEach(item => {
      let flag = false
      this.formData.snSiteInheritChangeDTOS.forEach(item1 => {
        console.log(" item1.id------", item1.inheritSiteId)
        flag = (item1.inheritSiteId == data.id) || flag
        //  this.$refs['xTable2'].commitProxy('reload');
      })
      console.log(" flag-----", flag)
      if (!flag) {
        this.formData.snSiteInheritChangeDTOS.push({ inheritSiteId: data.id, inheritSiteAccount: data.userAccount, inheritSiteName: data.name })

      }
      //})
      console.log(' this.formData.snSiteInheritChangeDTOS选中', this.formData.snSiteInheritChangeDTOS)

      this.reload()

    },

    //
    // areaconfirm(rows) {
    //   if (rows.length > 0) {
    //
    //     const tableData = this.table_area;
    //     const map = {};
    //     tableData.forEach(function (item) {
    //       map[item.preconditionId] = 1;
    //     });
    //     var items = [];
    //     rows.forEach((row, index) => {
    //       const item = {
    //         preconditionId: row.id,
    //         areaName: row.precondition
    //       };
    //       if (!map[item.preconditionId]) {
    //         items.push(item);
    //       }
    //     });
    //     this.table_area = this.table_area.concat(items);
    //   }
    // },
    // preconditionconfirm(rows) {
    //   if (rows.length > 0) {
    //
    //     const tableData = this.table_type;
    //     const map = {};
    //     tableData.forEach(function (item) {
    //       map[item.preconditionId] = 1;
    //     });
    //     var items = [];
    //     rows.forEach((row, index) => {
    //       const item = {
    //         preconditionId: row.id,
    //         typeName: row.precondition
    //       };
    //       if (!map[item.preconditionId]) {
    //         items.push(item);
    //       }
    //     });
    //     this.table_type = this.table_type.concat(items);
    //   }
    // },

    // // 上传成功
    // handleSuccess(response, file) {
    //   // 上传成功后，隐藏上传按钮
    //   this.upload_btn = true;
    //   // this.tenant.snCompanyBrandDTOS[picIndex].pic = res.data.url;
    //   // Vue.set(this.tenant.shopPhoto, 'pic', res.data.url)
    //
    // },
    // handleRemove(response, file) {
    //   // 上传成功后，显示上传按钮
    //   this.upload_btn = false;
    // },

    // // 上传成功
    // handleSuccess4(res, file, picIndex) {
    //   // 上传成功后，隐藏上传按钮
    //   this.upload_btn4 = true;
    //   // this.tenant.snCompanyBrandDTOS[picIndex].pic = res.data.url;
    //   Vue.set(this.tenant.businessPhoto,)
    //
    // },
    // handleRemove4(response, file) {
    //   // 上传成功后，显示上传按钮
    //   this.upload_btn4 = false;
    // },
    // handleDelete2(index) {
    //   this.table_area.splice(index, 1);
    // },
    // handleDelete(index) {
    //   this.table_type.splice(index, 1);
    // },

    // 第一个  表格
    formatter(row, column) {
      return row.address;
    },
    // 卡片事件
    //点击查看图片
    handlePictureCardPreview(file) {
      this.dialogImageUrlList = [file.url]
      this.dialogVisible = true;
      // console.log(fileList, "已上传文件")
    },
    // 上传发生变化钩子
    // 注意 :on-remove="handleimageChange"与:on-change="handleimageChange" 都绑定这个方法，这样无论是上传图片还是移除图片，都会更新图片数据列表
    // handleimageChange(file, fileList) {
    //   this.upload_img = fileList;
    //   // this.upload_img.imageName=fileList.name;
    //   console.log(fileList, "文件状态改变时")
    //   console.log(file, "文件状态改变时file")
    // },
  },
};

</script>
<style lang="scss" scoped>
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

.header_dialog {
  border-radius: 8px !important;
  height: 800px !important;
}

el-dialog {
  border-radius: 8px !important;
  box-shadow: 0 0 24px rgb(0 0 0 / 22%) !important;
}

v::deep .el-upload .el-upload--picture-card {
  position: relative;
  left: -200px;
}

// 单选框
.radio_item {
  width: 24%;
  margin-top: 10px;
  margin-bottom: 10px !important;

  > span {
    display: inline-block;
    width: 120px;
    margin-right: 13px;
    text-align: right;
    font-weight: 400;
    color: rgba(86, 86, 86, 0.96);
    font-size: 12px;
  }
}

.firm {
  .el-input {
    width: 150px;
  }
}

.type_title {
  font-weight: 400;
  text-align: right;
  width: 112px;
  position: relative;
  padding: 0 10px 0 4px;
  color: rgba(86, 86, 86, 0.96);
  font-size: 12px;
}

.type_select {
  width: 120px;
  text-align: center;
}

.type_brand {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;

  > div {
    margin: 16px 0;
    width: 25%;
  }
}

// 备注的样式
.annotate {
  padding: 0px !important;
  height: 28px !important;
  min-height: 28px !important;
}

.el-textarea__inner {
  padding: 0px !important;
  height: 28px !important;
  min-height: 28px !important;
}

// 装图片的  大框



::v-deep.el-upload-list__item.is-success .el-upload-list__item-status-label {
  display: none !important;
}

// 输入框的宽度
#containt .table-detail tbody tr td .el-input {
  width: 100% !important;
  width: 165px !important;
}

// Switch 开关  标题的宽度
.el-switch__label * {
  line-height: 1;
  width: 160px !important;
  display: inline-block;
  font-weight: 400;
  color: rgba(86, 86, 86, 0.96);
  font-size: 12px;
}

// 清楚表格 默认padding
.el-table--medium .el-table__cell {
  padding: 0px 0 !important;
}

.table_item {
  .el-table__row:hover > td {
    background-color: #D4E7FF !important;
  }
}


// 卡片样式
.card_item {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;


  .el-card__header {
    padding: 10px 20px 5px;
    border-bottom: 1px dashed #7a7e7c;
    font-weight: 600;
    font-size: 13px;
  }

  .el-card__body,
  .el-main {
    padding: 10px 20px;
  }

  .text {
    font-size: 12px;
  }

  .item {
    margin-bottom: 12px;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 30%;
    margin-right: 30px;
    margin-bottom: 30px;
    border: 1px solid #ccc !important;
  }
}

.papers {
  margin-left: 30px;
  position: absolute;



}

.btn_zdy {
  margin: 10px 0;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

.btn_zdy2 {
  // 选取文件合同按钮
  // margin: 10px 60px;
  margin-top: 6px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy2:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

#containt .detail-wrap .d-cont {
  overflow: auto !important;
}

::v-deep .vxe-grid .vxe-grid--pager-wrapper {
  display: block;
  width: 100%;
  position: fixed;
  bottom: -38px !important;
  position: absolute !important;
  z-index: 9999999;
  background-color: #ffffff;
}

.information {
  padding: 4px 10px;
  background-color: #E1F2FF;
  color: #268AEA;
  border-radius: 3px;
  margin: 0 5px;
}


</style>
